//Part of NavBar Content
//Add / change content in category to adjust NavBar

export const items = [
  {
    name: "gspl",
    category: "Product",
    href: "/GsplIndex",
    img: "/images/gspl-homepage-thumbnail.png",
  },
  {
    name: "gosse",
    category: "Product",
    href: "/GooseIndex",
    img: "/images/gosse.jpeg",
  },
  {
    name: "life-creations",
    category: "Digital",
    href: "/LifeCreationsIndex",
    img: "/images/life-creations-homepage-thumbnail.png",
  },
  {
    name: "cotta",
    category: "Digital",
    href: "/CottaIndex",
    img: "/images/cotta.jpeg",
  },
  {
    name: "flavour-flames",
    category: "Digital",
    href: "/FlavourFlamesIndex",
    img: "/images/flavour-flames-homepage-thumbnail.png",
  },
  {
    name: "soar",
    category: "Digital",
    href: "/SoarRisingIndex",
    img: "/images/soar.jpeg",
  },
  // {
  //   name: "cornerstone",
  //   category: "Digital",
  //   href: "/CornerstoneIndex",
  //   img: "/images/cornerstone.jpeg",
  // },
];
